import React, { useState, useEffect } from "react";
import "./Navbar.css";
import logoImage from "./underconstruction/images/logo.webp";
import Contacto from "./Contacto";
import SobreNosotros from "./SobreNosotros";

function Navbar({
  activeButton,
  resetContent,
  onContentReset,
  onNavbarStateChange,
  onButtonClick,
}) {
  const [showContact, setShowContact] = useState(false);
  const [showSobreNosotros, setShowSobreNosotros] = useState(false);
  const [lastClicked, setLastClicked] = useState(null); // Nuevo estado para el último botón clickeado

  useEffect(() => {
    if (resetContent) {
      setShowContact(false);
      setShowSobreNosotros(false);
      setLastClicked(null); // Resetear también el último botón clickeado
      onContentReset();
    }
  }, [resetContent]);

  useEffect(() => {
    if (activeButton !== 8 && activeButton !== 9) {
      setShowContact(false);
      setShowSobreNosotros(false);
    }
    onNavbarStateChange &&
      onNavbarStateChange({ showContact, showSobreNosotros });
  }, [activeButton, showContact, showSobreNosotros]);

  const handleClick = (index) => {
    if (index === lastClicked) {
      // Si el mismo botón se volvió a clickear
      setShowContact(false);
      setShowSobreNosotros(false);
      setLastClicked(null); // Resetear el último botón clickeado
      onButtonClick(null);
    } else {
      if (index === 8) {
        setShowSobreNosotros(true);
        setShowContact(false);
      } else if (index === 9) {
        setShowContact(true);
        setShowSobreNosotros(false);
      }
      setLastClicked(index); // Actualizar el último botón clickeado
      onButtonClick(index);
    }

    onNavbarStateChange &&
      onNavbarStateChange({ showContact, showSobreNosotros });
  };

  /**========================================================================
   *                           return
   *========================================================================**/
  /// [section_title]

  return (
    <div>
      <div className="navbar">
        <div className="logo-container">
          <img src={logoImage} alt="Mi Logo" className="logo" />
        </div>
        <div className="buttons">
          <button
            className={`navbar-about-us ${activeButton === 8 ? "active" : ""}`}
            onClick={() => handleClick(8)}
          >
            Sobre Nosotros
          </button>
          <button
            className={`navbar-contacto ${activeButton === 9 ? "active" : ""}`}
            onClick={() => handleClick(9)}
          >
            Contacto
          </button>
        </div>
      </div>
      <SobreNosotros isVisible={showSobreNosotros} />
      <Contacto isVisible={showContact} />
      <div className="frase">
        <span className="frasetexto">
          Más de 15 años en soluciones hiperbáricas
        </span>
      </div>
    </div>
  );
}

export default Navbar;
